import React from 'react';
import { pageHeaderFullWidth } from './Headers.styles';

interface IPageHeaderProps {
  title: () => JSX.Element;
  breadcrumb?: () => JSX.Element;
  subtitle?: () => JSX.Element;
}

const FullWidthHeader: React.FunctionComponent<IPageHeaderProps> = (props: IPageHeaderProps) => {
  const { title, breadcrumb, subtitle } = props;
  const Styles = pageHeaderFullWidth();
  return (
    <div className={`${Styles.pageHeaderWrapper}`}>
      {breadcrumb && <div className={Styles.pageBreadcrumb}>{breadcrumb()}</div>}
      <div className={Styles.pageHeaderTitle}>{title()}</div>
      {subtitle && <div className={Styles.pageSubheaderWrapper}>{subtitle()}</div>}
    </div>
  );
};

export default FullWidthHeader;
